import React from 'react';
//import { toast } from 'react-toastify';
//import { PaymentIntentResult } from '@stripe/stripe-js/types/stripe-js';
import { useStripe, PaymentRequestButtonElement } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';
import { PaymentRequestUpdateOptions, StripePaymentRequestButtonElementClickEvent } from '@stripe/stripe-js';
import { PaymentRequest } from '@stripe/stripe-js';
import { GlobalContext } from '../../../contexts/HomeContext';
// import { isObjectEmpty } from '../../../utils/utils';
// import { useSocketio } from '../../../contexts/SocketioContext';

type Props = {
  value: number;
  // eslint-disable-next-line no-unused-vars
  handleValidacao: (e?: boolean, isValidation?: boolean, paydAsAppleOrGoogle?: boolean, nsu?: string) => boolean;
  //handleValidacao: (e?: boolean, isValidation?: boolean) => boolean;
  clientSecret: string;
};

const CheckoutForm: React.FC<Props> = (props) => {
  const { dadosApp } = React.useContext(GlobalContext);
  // const { socketResponse } = useSocketio();
  // const _objPayment = document.getElementById('objPayment');
  const stripe = useStripe();
  //const elements = useElements();
  //const [isLoading, setIsLoading] = React.useState(false);
  const [paymentRequest, setPaymentRequest] = React.useState<PaymentRequest | null>(null);
  //const [message, setMessage] = React.useState('');
  const [formValidated, setFormValidated] = React.useState(dadosApp.Qs.Modulo === 'BALCAO'); // ja vem validado em caso de balcao

  const showPaymentText =
    !dadosApp.aceitaPagamentoSemUsuario &&
    dadosApp.Empresa.Config.pagamento_online === 1 &&
    dadosApp.Empresa.Config.debito_habilitado === 1;
  // React.useEffect(() => {
  //   if (!stripe) return;

  //   const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');

  //   if (!clientSecret) {
  //     return;
  //   }

  //   stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }: PaymentIntentResult) => {
  //     switch (paymentIntent?.status) {
  //       case 'succeeded':
  //         setMessage('Payment succeeded!');
  //         break;
  //       case 'processing':
  //         setMessage('Your payment is processing.');
  //         break;
  //       case 'requires_payment_method':
  //         setMessage('Your payment was not successful, please try again.');
  //         break;
  //       default:
  //         setMessage('Something went wrong.');
  //         break;
  //     }
  //   });
  // }, [stripe]);

  React.useEffect(() => {
    //if (stripe && props.value > 0) {
    if (stripe && props.value > 0) {
      const pr = stripe.paymentRequest({
        country: 'BR',
        currency: 'brl',
        total: {
          label: 'Garçom Web',
          amount: props.value,
        },
        requestPayerName: true,
        requestPayerEmail: true,
        disableWallets: ['link'],
      });

      // Check the availability of the Payment Request API.
      pr.canMakePayment().then((result) => {
        //alert(result?.toString());
        if (result) {
          if (paymentRequest) {
            const temp: PaymentRequestUpdateOptions = { total: { amount: props.value, label: 'Garçom Web' } };
            paymentRequest.update(temp);
          } else {
            setPaymentRequest(pr);
          }
        }
      });
    }
  }, [stripe, props.value, paymentRequest]);

  const handleEvents = React.useCallback(async () => {
    if (!stripe) return;
    if (!paymentRequest) return;

    paymentRequest.on('paymentmethod', async (ev: any) => {
      // Confirm the PaymentIntent without handling potential next actions (yet).
      const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
        props.clientSecret,
        { payment_method: ev.paymentMethod.id },
        { handleActions: false },
      );

      if (confirmError) {
        // Report to the browser that the payment failed, prompting it to
        // re-show the payment interface, or show an error message and close
        // the payment interface.
        // setMessage(confirmError.message || '');
        toast.error(confirmError.message, { autoClose: 5000 });
        ev.complete('fail');
      } else {
        // Report to the browser that the confirmation was successful, prompting
        // it to close the browser payment method collection interface.
        ev.complete('success');
        // Check if the PaymentIntent requires any actions and if so let Stripe.js
        // handle the flow. If using an API version older than "2019-02-11"
        // instead check for: `paymentIntent.status === "requires_source_action"`.
        if (paymentIntent.status === 'requires_action') {
          // Let Stripe.js handle the rest of the payment flow.
          const { error } = await stripe.confirmCardPayment(props.clientSecret);
          if (error) {
            // The payment failed -- ask your customer for a new payment method.
            toast.error('O Pagamento falhou, tente outra forma de pagamento ', { autoClose: 7000 });
          } else {
            // The payment has succeeded.
            //toast.success('Pagamento Realizado com Sucesso', { autoClose: 5000 });
            // envia o pedido
            await props.handleValidacao(undefined, false, true, paymentIntent?.id); // envia o pedido
          }
        } else {
          // The payment has succeeded.
          //toast.success('Pagamento Realizado com Sucesso', { autoClose: 5000 });
          // envia o pedido
          await props.handleValidacao(undefined, false, true, paymentIntent?.id);
        }
      }
    });
  }, [stripe, props, paymentRequest]);

  // ESCUTA OS EVENTOS DO SOCKET.IO
  // const handleResposta = React.useCallback(
  //   (data: any) => {
  //     if (data) {
  //       switch (data.Solicitacao) {
  //         case '8': // auto atendimento balcao
  //           if (data.readed) return;
  //           if (data.Status === 0) {
  //             setFormValidated(true);

  //             setTimeout(() => {
  //               if (_objPayment) _objPayment.click(); // clica no botão do ApplePay/GooglePay
  //             }, 400);

  //             //paymentRequest?.show();
  //           } else {
  //             toast.error(data.Body, { containerId: 'modalToast' });
  //           }
  //           return;

  //         default:
  //           break;
  //       }
  //     }
  //     data.readed = true;
  //   },
  //   [_objPayment],
  // );

  React.useEffect(() => {
    handleEvents();
  }, [handleEvents]);

  // React.useEffect(() => {
  //   if (!isObjectEmpty(socketResponse)) {
  //     handleResposta(socketResponse);
  //   }
  //   //return () => socketResponse;
  // }, [socketResponse, handleResposta]);

  // React.useEffect(() => {

  // }, []);

  // const handleSubmit = async (event: React.MouseEvent<any>) => {
  //   event.preventDefault();

  //   if (!stripe || !elements) {
  //     // Stripe.js has not yet loaded.
  //     // Make sure to disable form submission until Stripe.js has loaded.
  //     return;
  //   }

  //   // VALIDA O FORM DE FINALIZAÇÃO
  //   if (!obj.handleValidacao(true)) return;

  //   setIsLoading(true);

  //   const { error } = await stripe.confirmPayment({
  //     elements,
  //     confirmParams: {
  //       return_url: 'http://localhost:3002',
  //       //return_url: 'https://example.com/order/123/complete',
  //     },
  //     //redirect: 'if_required',
  //   });
  //
  //   // This point will only be reached if there is an immediate error when
  //   // confirming the payment. Otherwise, your customer will be redirected to
  //   // your `return_url`. For some payment methods like iDEAL, your customer will
  //   // be redirected to an intermediate site first to authorize the payment, then
  //   // redirected to the `return_url`.
  //   if (error.type === 'card_error' || error.type === 'validation_error') {
  //     toast.error(error?.message || 'An unexpected error occurred.', { containerId: 'toastGeral', autoClose: 7000 });

  //     setMessage(error?.message || 'An unexpected error occurred.');
  //   } else {
  //     toast.error('An unexpected error occurred.', { containerId: 'toastGeral', autoClose: 7000 });
  //     setMessage('An unexpected error occurred.');
  //   }

  //   setIsLoading(false);
  // };

  if (paymentRequest) {
    return (
      <div style={{ borderTop: '1px solid rgb(235, 235, 235)' }}>
        <div style={{ margin: 20, padding: 20 }}>
          <PaymentRequestButtonElement
            id="objPayment"
            options={{ paymentRequest }}
            onClick={async (e: StripePaymentRequestButtonElementClickEvent) => {
              if (!formValidated) {
                e.preventDefault();
                // VALIDA O FORM DE FINALIZAÇÃO
                const _isValid = await props.handleValidacao(undefined, true);
                //toast.info('_isValid: ' + _isValid, { autoClose: 5000 });
                setFormValidated(_isValid);
                if (_isValid) paymentRequest?.show(); // abre o popup de pagamento
              }
            }}
          />
          {/* {message && <div id="payment-message">{message}</div>} */}
        </div>

        {/* {!dadosApp.aceitaPagamentoSemUsuario && ( */}
        {/* {!dadosApp.aceitaPagamentoSemUsuario && dadosApp.Empresa.Config.pagamento_online === 1 && dadosApp.Empresa.Config.debito_habilitado === 1 && ( */}
        {showPaymentText && (
          <div
            style={{
              textAlign: 'center',
              margin: 20,
              display: dadosApp.Empresa.Config.pix_habilitado === 1 ? 'none' : 'block',
            }}
          >
            <p
              style={{
                fontSize: 13,
                margin: '0 auto -30px',
                background: 'rgb(254, 254, 254)',
                width: '170px',
                position: 'relative',
                zIndex: 10,
              }}
            >
              Ou pague com cartão
            </p>
          </div>
        )}

        {/*
        <div style={{ margin: 20 }} className="cardShadow">
           <form id="payment-form" onSubmit={handleSubmit}>
            <LinkAuthenticationElement id="link-authentication-element" onChange={(e) => setEmail(e.value.toString())} />
            <PaymentElement id="payment-element" />

            <button disabled={isLoading || !stripe || !elements} id="submit" className="btn_1 full-width mb_5 btnFinalizar">
              <span id="button-text">{isLoading ? <div className="spinner" id="spinner"></div> : 'Pagar Agora'}</span>
            </button>

            {message && <div id="payment-message">{message}</div>}
          </form>
        </div>
        */}
      </div>
    );
  } else {
    return <div style={{ textAlign: 'center', width: `100%` }}></div>;
  }
};

export default CheckoutForm;
